import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import moment from "moment-timezone";
import DPServices from "@dp/services";
import { ORDER_TYPES } from "@dp/common";
import { PaymentFlow } from "./types";
var DATE_FORMAT = "MM/DD/YYYY";
/* 
findMenuItemAvailibilityFromDayPartInfo funtion will check availbility of 
menu items on selected pickup date. This function returning unavailable flag. Accepts 3 parameters productid, dayPartInfo, selectedPickTime.
daypartinfo details we will get 4 types of information of menu item
    1. advanceOrderMessage - unavailable message for menu item 
    2. daySelection - the details of on which days a menu item is available and at what time a menu item is available
    3. startDate | endDate -  menu item will available between startDate and endDate
    4. unavailableStartDate | unavailableEndDate -  menu item will unavailable between unavailableStartDate and unavailableStartDate

  To find menu avaibility we need to check all above details considering below conditions for selectedPickUpDate-
    A. checking selected pickup date is between startdate and end date
    B. checking selected pickup date is between unavailableStartDate | unavailableEndDate
    C. checking on selected day menu item is available using day selection details

    if condition (A) and (C) satifies and not (B) then menu item will be available.
    if only daySelection detail available, on (C) satifies menu item will be available. 
    if only startDate and endDate detail available, on (A) satifies menu item will be available.
    if only unavailableStartDate and unavailableEndDate detail available, on (B) satifies menu item will be not available.

*/

export var findMenuItemAvailibilityFromDayPartInfo = function findMenuItemAvailibilityFromDayPartInfo(id, _dayPartInfo, _currentPickupTime) {
  var _dayPartInfo$productD;

  var unAvailableMessage = "";
  if (!(_dayPartInfo !== null && _dayPartInfo !== void 0 && _dayPartInfo.productDaypartInfos)) return {
    isUnavailable: false,
    unAvailableMessage: unAvailableMessage
  };
  var productDayPartInfo = _dayPartInfo === null || _dayPartInfo === void 0 ? void 0 : (_dayPartInfo$productD = _dayPartInfo.productDaypartInfos[id]) === null || _dayPartInfo$productD === void 0 ? void 0 : _dayPartInfo$productD[0];
  if (!productDayPartInfo) return {
    isUnavailable: false,
    unAvailableMessage: unAvailableMessage
  };
  var isProductAvailableByDaySelection = false;
  var isProductAvailableByAvailableDates = false;
  var isProductAvailableByUnAvailableDates = false;
  var pickupStartTimeMomentObject = moment(_currentPickupTime === null || _currentPickupTime === void 0 ? void 0 : _currentPickupTime.startTimeInMs);

  if (productDayPartInfo !== null && productDayPartInfo !== void 0 && productDayPartInfo.advanceOrderMessage) {
    unAvailableMessage = productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : productDayPartInfo.advanceOrderMessage;
  }

  isProductAvailableByDaySelection = _findMenuAvaibilityByDaySelection(pickupStartTimeMomentObject, productDayPartInfo);
  isProductAvailableByAvailableDates = _findMenuAvaibilityByAvailableDates(pickupStartTimeMomentObject, productDayPartInfo);
  isProductAvailableByUnAvailableDates = _findMenuAvaibilityByUnAvailableDates(pickupStartTimeMomentObject, productDayPartInfo);
  if (isProductAvailableByDaySelection && isProductAvailableByAvailableDates && isProductAvailableByUnAvailableDates) return {
    isUnavailable: false,
    unAvailableMessage: unAvailableMessage
  };
  return {
    isUnavailable: true,
    unAvailableMessage: unAvailableMessage
  };
};

var isDateInBetween = function isDateInBetween(time, startTime, endTime) {
  return time.isBetween(startTime, endTime, undefined, "[]") ? true : false;
}; // To find menu avaibility by day selection details


var _findMenuAvaibilityByDaySelection = function _findMenuAvaibilityByDaySelection(pickupStartTimeMomentObject, productDayPartInfo) {
  var _productDayPartInfo$d;

  var isAvailable = false;

  if (productDayPartInfo !== null && productDayPartInfo !== void 0 && (_productDayPartInfo$d = productDayPartInfo.daysSelection) !== null && _productDayPartInfo$d !== void 0 && _productDayPartInfo$d.length) {
    var _productDayPartInfo$d2;

    var selectedDayTimeInformation = productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : (_productDayPartInfo$d2 = productDayPartInfo.daysSelection) === null || _productDayPartInfo$d2 === void 0 ? void 0 : _productDayPartInfo$d2.find(function (_d) {
      return pickupStartTimeMomentObject.day() + 1 === _d.dayName;
    });

    if (selectedDayTimeInformation) {
      var pickupStartTimeMomentObjectTime = moment(moment(pickupStartTimeMomentObject).format("HH:mm:ss"), "HH:mm:ss");
      isAvailable = isDateInBetween(pickupStartTimeMomentObjectTime, moment(selectedDayTimeInformation === null || selectedDayTimeInformation === void 0 ? void 0 : selectedDayTimeInformation.startTime, "HH:mm:ss"), moment(selectedDayTimeInformation === null || selectedDayTimeInformation === void 0 ? void 0 : selectedDayTimeInformation.endTime, "HH:mm:ss"));
    }
  } else {
    isAvailable = true;
  }

  return isAvailable;
}; // To find menu avaibility by available startdate and enddate details from daypartinfo


var _findMenuAvaibilityByAvailableDates = function _findMenuAvaibilityByAvailableDates(pickupStartTimeMomentObject, productDayPartInfo) {
  var availableStartDate = productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : productDayPartInfo.startDate;
  var availableEndDate = productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : productDayPartInfo.endDate;
  return availableStartDate && availableEndDate ? isDateInBetween(pickupStartTimeMomentObject, moment(availableStartDate === null || availableStartDate === void 0 ? void 0 : availableStartDate.time), moment(availableEndDate === null || availableEndDate === void 0 ? void 0 : availableEndDate.time)) : true;
}; // To find menu avaibility by unavailable startdate and enddate details from daypartinfo


var _findMenuAvaibilityByUnAvailableDates = function _findMenuAvaibilityByUnAvailableDates(pickupStartTimeMomentObject, productDayPartInfo) {
  var _productDayPartInfo$u, _productDayPartInfo$u2;

  return productDayPartInfo !== null && productDayPartInfo !== void 0 && productDayPartInfo.unavailableStartDate && productDayPartInfo !== null && productDayPartInfo !== void 0 && productDayPartInfo.unavailableEndDate ? !isDateInBetween(pickupStartTimeMomentObject, moment(productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : (_productDayPartInfo$u = productDayPartInfo.unavailableStartDate) === null || _productDayPartInfo$u === void 0 ? void 0 : _productDayPartInfo$u.time), moment(productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : (_productDayPartInfo$u2 = productDayPartInfo.unavailableEndDate) === null || _productDayPartInfo$u2 === void 0 ? void 0 : _productDayPartInfo$u2.time)) : true;
};

export var _getFormattedDate = function _getFormattedDate(time) {
  var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var today = moment();
  var tomorrow = moment().add(1, "days");
  var date = moment(time);
  if (date.isSame(today, "d")) return date.format("[Today], MMM Do" + (includeTime ? ", hh:mm a" : ""));else if (date.isSame(tomorrow, "d")) return date.format("[Tomorrow], MMM Do" + (includeTime ? ", hh:mm a" : ""));else {
    if (includeTime) {
      return date.format("MMM Do, hh:mm a");
    } else {
      return date.format(DATE_FORMAT);
    }
  }
};
export var fetchDistances = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(myCoords, restSearchResults) {
    var resultObj, resultsLength, start, end, noOfCall, i, obj;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            resultObj = {};
            resultsLength = restSearchResults.length;
            noOfCall = Math.ceil(resultsLength / 24);
            i = 0;

          case 5:
            if (!(noOfCall > i)) {
              _context.next = 15;
              break;
            }

            start = 24 * i;
            end = resultsLength < 24 * (i + 1) ? resultsLength : 24 * (i + 1);
            _context.next = 10;
            return fetchDistancesAPI(myCoords, restSearchResults.slice(start, end));

          case 10:
            obj = _context.sent;
            resultObj = _objectSpread(_objectSpread({}, resultObj), obj);
            i++;
            _context.next = 5;
            break;

          case 15:
            return _context.abrupt("return", resultObj);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {});

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 18]]);
  }));

  return function fetchDistances(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchDistancesAPI = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(myCoords, restSearchResults) {
    var tempApiStr, tempCurbStr, resultObj, distanceResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            tempApiStr = "";
            tempCurbStr = "curb;";
            resultObj = {};
            tempApiStr += myCoords.longitude.toString() + "," + myCoords.latitude.toString() + ";";
            restSearchResults === null || restSearchResults === void 0 ? void 0 : restSearchResults.forEach(function (data, idx) {
              tempApiStr += data.longitude.toString() + "," + data.latitude.toString();
              tempCurbStr = tempCurbStr + "curb";

              if (idx !== restSearchResults.length - 1) {
                tempApiStr += ";";
                tempCurbStr += ";";
              }
            });
            _context2.next = 8;
            return DPServices.Location.getRestaurantDistance(tempApiStr, tempCurbStr);

          case 8:
            distanceResult = _context2.sent;
            distanceResult === null || distanceResult === void 0 ? void 0 : distanceResult.forEach(function (data, idx) {
              if (idx > 0) {
                var _key = restSearchResults[idx - 1].restaurantId;
                var distInKms = data / 1000;
                var distInMiles = distInKms * 0.621371;
                resultObj[_key] = Math.floor(distInMiles) ? Math.floor(distInMiles) : -1;
              }
            });
            return _context2.abrupt("return", resultObj);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", {});

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 13]]);
  }));

  return function fetchDistancesAPI(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchDistanceFromRestuarant = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(myCoords, restaurantDetails) {
    var _restaurantDetails$ad, _restaurantDetails$ad2, tempApiStr, tempCurbStr, mapAttributes, latitude, longitude, resultObj, distanceResult;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            tempApiStr = "";
            tempCurbStr = "curb;";
            mapAttributes = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$ad = restaurantDetails.address) === null || _restaurantDetails$ad === void 0 ? void 0 : (_restaurantDetails$ad2 = _restaurantDetails$ad.longitudeLatitude) === null || _restaurantDetails$ad2 === void 0 ? void 0 : _restaurantDetails$ad2.split(",");
            latitude = mapAttributes[0];
            longitude = mapAttributes[1];
            resultObj = {};
            tempApiStr += myCoords.longitude.toString() + "," + myCoords.latitude.toString() + ";";
            tempApiStr += longitude.toString().trim() + "," + latitude.toString();
            _context3.next = 11;
            return DPServices.Location.getRestaurantDistance(tempApiStr, tempCurbStr);

          case 11:
            distanceResult = _context3.sent;
            distanceResult === null || distanceResult === void 0 ? void 0 : distanceResult.forEach(function (data, idx) {
              if (idx > 0) {
                var _key2 = restaurantDetails.restaurantInfo;
                var distInKms = data / 1000;
                var distInMiles = distInKms * 0.621371;
                console.log("current location distinMiles,", distInMiles);
                resultObj[_key2] = distInMiles;
              }
            });
            return _context3.abrupt("return", resultObj);

          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", {});

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 16]]);
  }));

  return function fetchDistanceFromRestuarant(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}(); // https://www.geodatasource.com/developers/javascript function to calculate distance between two co-ordinates

export var distanceBetweenCoordinates = function distanceBetweenCoordinates(coords1, coords2) {
  var lat1 = coords1.latitude;
  var lon1 = coords1.longitude;
  var lat2 = coords2.latitude;
  var lon2 = coords2.longitude;

  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

    if (dist > 1) {
      dist = 1;
    }

    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    return dist;
  }
};
export var decodeIsAlcohol = function decodeIsAlcohol(isAlcohol, restaurantDetails, alcoholSubClassification, orderType) {
  var isPickupOrder = orderType === ORDER_TYPES.TOGO_PICKUP || orderType === ORDER_TYPES.CATERING_PICKUP && (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isAlcoholAllowedForToGo);
  var isDeliveryOrder = orderType === ORDER_TYPES.CATERING_DELIVERY && (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isAlcoholAllowedForDelivery);
  var result = false;
  var toolTipMessage = "";

  if (isAlcohol) {
    if (isPickupOrder) {
      toolTipMessage = "DINE IN ONLY";

      switch (alcoholSubClassification) {
        case "LIQUOR":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isLiquorAllowedForToGo;
          break;

        case "BEER":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isBeerAllowedForToGo;
          break;

        case "WINE":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isWineAllowedForToGo;
          break;

        case undefined:
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isAlcoholAllowedForToGo;
      }
    }

    if (isDeliveryOrder) {
      toolTipMessage = "Sorry, this location do not deliver alcohol items";

      switch (alcoholSubClassification) {
        case "LIQUOR":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isLiquorAllowedForDelivery;
          break;

        case "BEER":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isBeerAllowedForDelivery;
          break;

        case "WINE":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isWineAllowedForDelivery;
          break;

        case undefined:
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isAlcoholAllowedForDelivery;
      }
    }

    if (!result) {
      return {
        isAlcohol: true,
        toolTipMessage: toolTipMessage
      };
    }
  }

  return {
    isAlcohol: false,
    toolTipMessage: toolTipMessage
  };
};
export var decodeIsAdvanceOrderingProduct = function decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage, isAdvanceOrderingAllowed) {
  return isUnavailable && unAvailableMessage && (unAvailableMessage === null || unAvailableMessage === void 0 ? void 0 : unAvailableMessage.length) && isAdvanceOrderingAllowed === "true";
};
export var findProductAvailableStartDate = function findProductAvailableStartDate(id, _dayPartInfo) {
  var _dayPartInfo$productD2, _productDayPartInfo$s;

  var productDayPartInfo = _dayPartInfo === null || _dayPartInfo === void 0 ? void 0 : (_dayPartInfo$productD2 = _dayPartInfo.productDaypartInfos[id]) === null || _dayPartInfo$productD2 === void 0 ? void 0 : _dayPartInfo$productD2[0];
  return productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : (_productDayPartInfo$s = productDayPartInfo.startDate) === null || _productDayPartInfo$s === void 0 ? void 0 : _productDayPartInfo$s.time;
};
export var isOrderAheadRestaurant = function isOrderAheadRestaurant(orderAheadListOfRestaurants, orderAheadRestaurantId, orderAheadEnabled, disableOrderAheadBtnOnRDP) {
  if (!orderAheadListOfRestaurants || !disableOrderAheadBtnOnRDP) return false;
  var showOrderAheadListOfRestaurants = orderAheadListOfRestaurants === null || orderAheadListOfRestaurants === void 0 ? void 0 : orderAheadListOfRestaurants.split(",");
  if (!(showOrderAheadListOfRestaurants !== null && showOrderAheadListOfRestaurants !== void 0 && showOrderAheadListOfRestaurants.length)) return false;
  var orderAheadRestaurant = showOrderAheadListOfRestaurants.find(function (restaurantId) {
    return restaurantId === orderAheadRestaurantId;
  });
  if (!orderAheadRestaurant) return false;
  return orderAheadEnabled && disableOrderAheadBtnOnRDP === "false";
};
export var getDialogueCode = function getDialogueCode(props) {
  var platformCode = props.isPlatformMobileApp ? "1" : "2";

  var paymentFlowCode = function () {
    var orderFlow = null;

    if (props.paymentFlow === PaymentFlow.CHECKOUT) {
      orderFlow = "14";
    } else if (props.paymentFlow === PaymentFlow.GC_CHECKOUT) {
      orderFlow = "3";
    } else {
      orderFlow = "2";
    }

    if (orderFlow === "2") {
      switch (props.paymentFlow) {
        case PaymentFlow.MPAY_CLQ:
          return orderFlow.concat("1");

        case PaymentFlow.MPAY_TLQ:
          return orderFlow.concat("2");

        case PaymentFlow.MPAY_OPCIO:
          return orderFlow.concat("3");

        default:
          return orderFlow.concat("");
      }
    }

    return orderFlow;
  }();

  return "".concat(platformCode, paymentFlowCode, props.errorCodeToAppend);
};